// Core
import React, { useEffect, useState } from "react";

// Redux
import { useDispatch } from "react-redux";
import { getUserDetailsRequest } from "../../../../../Redux/Slices/Common/commonSlice";
import { updateStaffDetailsRequest_ADMIN } from "../../../../../Redux/Slices/Admin/adminSlice";

// Custom functions
import { validateInput } from "Services/Utils/validateInput";
import { notifySuccess } from "Services/Utils/toastNotification";

// Custom component
import Button from "Components/Button";
import InputBox from "Components/InputBox";
import ErrorMessage from "Components/ErrorMessage";

const ProfileSettings = ({ goToNextTab }) => {
  //Initialize redux
  const dispatch = useDispatch();

  // Initial state for form data and errors
  const initialFormData = {
    accessorName: "",
    employeeId: "",
    email: "",
    mobileNumber: "",
    countryCode: "",
  };
  const initialErrors = {};

  // Local states
  const [formData, setFormData] = useState(initialFormData);
  const [errors, setErrors] = useState(initialErrors);
  const [userDetails, setUserDetails] = useState({});

  useEffect(() => {
    getUserDetailsRequestCall();
  }, []);

  // To get the user details
  const getUserDetailsRequestCall = () => {
    dispatch(
      getUserDetailsRequest({
        callBack: getUserDetailsCBRequest,
      })
    );
  };

  // To handle the response of getUserDetailsRequest
  const getUserDetailsCBRequest = (data) => {
    setFormData({
      accessorName: data?.user_name,
      employeeId: data?.user_code,
      email: data?.email,
      mobileNumber: data?.mobile,
      countryCode: data?.country_code,
    });
    setUserDetails(data);
  };

  const settingBoxStyle = {
    border: "1px solid #858485",
    borderRadius: "12px",
    outline: "none",
    width: "100%",
    maxWidth: "480px",
  };
  const settingLabelStyle = {
    color: "#545454",
    fontSize: "16px",
    fontWeight: "400",
  };
  const buttonTitleStyle = {
    fontSize: "16px",
    fontWeight: "600",
  };

  const buttonStyle = {
    height: "44px",
    width: "170px",
    whiteSpace: "nowrap",
    borderRadius: "12px",
  };

  // Handle input change
  const handleChange = (e) => {
    const { name, value } = e.target;

    // Update form data
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));

    // Clear error for the specific field
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: "",
    }));
  };

  // Validate form data based on type
  const handleValidation = () => {
    let validationErrors = {};

    Object.keys(formData).forEach((key) => {
      const error = validateInput(key, formData[key]);
      if (Object.keys(error).length > 0) {
        validationErrors = { ...validationErrors, ...error };
      }
    });

    setErrors(validationErrors);
    return validationErrors;
  };

  // Validate and handle form submission
  const handleSubmit = (e) => {
    e.preventDefault();

    // Validate passwords
    const validationErrors = handleValidation();

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
    } else {
      // Submit logic here
      dispatch(
        updateStaffDetailsRequest_ADMIN({
          userId: userDetails?.user_id,
          data: {
            user_name: formData?.accessorName,
            user_code: formData?.employeeId,
            mobile: formData?.mobileNumber,
            email: formData?.email,
          },
          callBack: updateStaffDetailsRequestCB_ADMIN,
        })
      );
    }
  };

  // To handle the response of updateStaffDetailsRequest_ADMIN
  const updateStaffDetailsRequestCB_ADMIN = () => {
    notifySuccess("Profile settings updated successfully!");
    goToNextTab();
  };

  return (
    <div className="p-4">
      <form onSubmit={handleSubmit}>
        <div className="row">
          <div className="col-6 mb-5 mt-2">
            <InputBox
              disabled="true"
              label="Assessor Name"
              name="accessorName"
              required
              value={formData.accessorName}
              onChange={handleChange}
              inputStyle={settingBoxStyle}
              labelStyle={settingLabelStyle}
            />
            <ErrorMessage message={errors.accessorName} />
          </div>
          <div className="col-6 mb-5 mt-2">
            <InputBox
              disabled="true"
              label="Employee ID"
              name="employeeId"
              required
              value={formData.employeeId}
              onChange={handleChange}
              inputStyle={settingBoxStyle}
              labelStyle={settingLabelStyle}
            />
            <ErrorMessage message={errors.employeeId} />
          </div>
          <div className="col-6 ">
            <InputBox
              disabled="true"
              label="Email ID"
              name="email"
              required
              value={formData.email}
              onChange={handleChange}
              inputStyle={settingBoxStyle}
              labelStyle={settingLabelStyle}
            />
            <ErrorMessage message={errors.email} />
          </div>
          <div className="col-6">
            <InputBox
              disabled="true"
              label="Mobile Number"
              name="mobileNumber"
              type="tel"
              maxLength={10}
              required
              value={`${formData.countryCode || ''} ${formData.mobileNumber || ''}`}
              onChange={handleChange}
              inputStyle={settingBoxStyle}
              onInput={(e) => {
                e.target.value = e.target.value.replace(/[^0-9]/g, '');
              }}
              labelStyle={settingLabelStyle}
            />
            <ErrorMessage message={errors.mobileNumber} />
          </div>
        </div>
        {/* <div className="col-2 mt-5">
           <Button
            title="Submit & Next"
            titleStyle={buttonTitleStyle}
            buttonStyle={buttonStyle}
            forForm
          /> 
        </div> */}
      </form>
    </div>
  );
};

export default ProfileSettings;
